module.exports = __webpack_public_path__ + "static/img/6792_phase_function_Paper_Points.458887c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6792_phase_function_Paper_Points.png
// module id = W/a/
// module chunks = 0